import styled from '@emotion/styled'

import { DrawerDivider, InputLabel } from 'components/patterns'

export const StyledInputSection = styled.div(
  (props) => `  
    ${DrawerDivider} {
      margin-bottom: 0;
    }
    & > ${InputLabel} {
      margin-top: 15px;
      display: inline-block;
    }

      .input-row {
      display: flex;
      gap: 3px;
      margin-top: 15px;
    }
  `
)
